import React from 'react';
import BetaChip from '../common/BetaChip/BetaChip';
import { formatCurrencySigFig, formatNumberSigFig } from '../../utils/formatters';
import type { RegistryComponentProps } from '../../pages/registry/componentRegistry';
import { getRegistryData } from '../../pages/registry/componentRegistry';
import { usePageDataContextOptional } from '../../contexts/PageDataContext';
import './CommercialCard.css';

interface CommercialCardData {
  year?: string;
  landedExVesselValue?: number;
  missedRevenueToFishermen?: number;
  landedEconomicImpact?: number;
  jobs?: number;
  landedMeals?: number;
}

export default function CommercialCard(props: RegistryComponentProps): React.ReactElement {
  const pageData = usePageDataContextOptional();
  const injectionData = getRegistryData<CommercialCardData>(props);

  // Prefer PageDataContext fisheryStats when available, else use injections
  const fisheryStats = (pageData?.data?.fisheryStats as CommercialCardData | undefined) ?? injectionData;
  const {
    year,
    landedExVesselValue,
    missedRevenueToFishermen,
    landedEconomicImpact,
    jobs,
    landedMeals,
  } = fisheryStats;

  return (
    <div className="commercial-card">
      <div className="commercial-card__title-row">
        <h3 className="commercial-card__title">Commercial {year && `(${year})`}</h3>
      </div>
      <div className="commercial-card__columns">
        <div className="commercial-card__column">
          <div className="commercial-card__metric">
            <span className="commercial-card__label">Landed Ex-vessel Value</span>
            <span className="commercial-card__value">{formatCurrencySigFig(landedExVesselValue)}</span>
          </div>
          <div className="commercial-card__metric">
            <span className="commercial-card__label commercial-card__label--with-chip">
              Missed Revenue to Fishermen <BetaChip />
            </span>
            <span className="commercial-card__value">{formatCurrencySigFig(missedRevenueToFishermen)}</span>
          </div>
          <div className="commercial-card__metric">
            <span className="commercial-card__label">Landed Economic Impact</span>
            <span className="commercial-card__value">{formatCurrencySigFig(landedEconomicImpact)}</span>
          </div>
          <div className="commercial-card__metric">
            <span className="commercial-card__label commercial-card__label--with-chip">
              Jobs <BetaChip />
            </span>
            <span className="commercial-card__value">{formatNumberSigFig(jobs)}</span>
          </div>
          <div className="commercial-card__metric">
            <span className="commercial-card__label commercial-card__label--with-chip">
              Landed Meals <BetaChip />
            </span>
            <span className="commercial-card__value">{formatCurrencySigFig(landedMeals)}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
